<template>
	<div>
		<!-- 搜索条件区域 -->
		<div class="search-container">
			<div class="search-form">
				<div class="form-item">
					<span class="label">姓名：</span>
					<el-input v-model="queryParams.personName" placeholder="请输入姓名" clearable></el-input>
				</div>
				<div class="form-item">
					<span class="label">身份证号：</span>
					<el-input v-model="queryParams.idCard" placeholder="请输入身份证号" clearable></el-input>
				</div>
				<div class="form-buttons">
					<el-button type="primary" @click="handleSearch">查询</el-button>
					<el-button @click="handleResetSearch">重置</el-button>
				</div>
			</div>
		</div>

		<data-table
			ref="staffLibraryTable"
			:table-data="staffLibraryList"
			:column="dataColumns"
			:border="false"
			header-cell-class="th1"
			cell-class-name="cell1"
			:index="true"
			:loading="loading"
			:page-options="pageOptions"
			:selection="isSetting"
			:reserve-selection="true"
			:row-keys="handleRowKeys"
			@selectionChange="handleStaffSelect"
			@page-change="handlePageChange"
		></data-table>
	</div>
</template>

<script>
	import DataTable from '@/components/JrTable/DataTable.vue'
	import { queryJzyhSelfRegisterPerson } from '@/api/certTreasure/materialRecord'

	// 建筑业-人员库组件
	export default {
		name: 'StaffLibrary',
		components: {
			DataTable
		},
		props: {
			// 是否可以选择人员
			isSetting: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				loading: false,
				pageOptions: {
					limit: 10,
					page: 1,
					total: 0
				},
				queryParams: {
					personName: '',
					idCard: ''
				},
				// 企业人员库数据
				staffLibraryList: [],
				dataColumns: [
					{ label: '姓名', prop: 'personName', align: 'center' },
					{ label: '人员岗位', prop: '', align: 'center' },
					{ label: '证书类型', prop: 'certificateName', align: 'center' },
					{ label: '身份证号', prop: 'idCard', align: 'center' },
					{ label: '发证单位', prop: '', align: 'center' },
					{ label: '证书编号', prop: 'certificateCode', align: 'center', width: 240 },
					{ label: '证书有效期', prop: 'validityTime', align: 'center' }
				],
				// 所选人员id集合
				staffIdArray: []
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.queryJzyhSelfRegisterPerson()
		},
		methods: {
			// 查询人员库列表
			queryJzyhSelfRegisterPerson() {
				this.loading = true
				const params = {
					// 证书类型：8：除特人员以外人员，9：特种人员
					// certificateType: '8',
					// certType: '主要负责人(A类)',
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					personType: '注册人员',
					...this.queryParams
				}

				queryJzyhSelfRegisterPerson(params)
					.then(response => {
						const { data } = response
						if (data.records && data.records.length > 0) {
							this.staffLibraryList = data.records
							this.pageOptions.total = data.total
							this.loading = false
						} else {
							this.staffLibraryList = []
							this.pageOptions.total = 0
							this.loading = false
						}
					})
					.catch(error => {
						this.staffLibraryList = []
						this.pageOptions.total = 0
						this.loading = false
					})
			},

			// 分页加载
			handlePageChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit
				this.queryJzyhSelfRegisterPerson()
			},

			// 搜索
			handleSearch() {
				this.pageOptions.page = 1
				this.pageOptions.limit = 10
				this.queryJzyhSelfRegisterPerson()
			},

			// 重置搜索
			handleResetSearch() {
				this.queryParams = {
					personName: '',
					idCard: ''
				}
				this.queryJzyhSelfRegisterPerson()
			},

			handleRowKeys(row) {
				return row.id
			},

			// 人员库数据选择回调
			handleStaffSelect(selection) {
				// 字段映射配置
				const fieldMapping = [
					'id',
					'personName',
					'certType',
					'sex',
					'idCard',
					'registerType',
					'registerSubType',
					'certificateName',
					'certificateGrade',
					'certificateCode',
					'certificateType',
					'registerCode',
					'registerUnitName',
					'registerUnitCode',
					'registerProject',
					'registerTime',
					'validityTime'
				]

				// 转换数据字段
				this.staffIdArray = selection.map(item => {
					const newItem = {}
					fieldMapping.forEach(field => {
						newItem[field] = item[field]
					})

					return newItem
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	// 个人中心-搜索区域
	.search-container {
		// background: #fff;
		padding: 10px;
		// border-radius: 4px;
		margin-bottom: 20px;
		// border: 1px solid #ebeef5;
		// box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

		.search-form {
			display: flex;
			flex-wrap: wrap;
			gap: 20px;

			.form-item {
				display: flex;
				align-items: center;

				.label {
					white-space: nowrap;
					margin-right: 8px;
					color: #606266;
				}

				.el-input {
					width: 200px;
				}

				.el-select {
					width: 200px;
				}

				.el-date-picker {
					width: 400px;
				}
			}
		}
	}
</style>
